export default __webpack_public_path__ + "static/media/InsideEars_09.6dc56333.png";